cv.featureEnabled = function(model, feature){
  var feature_flags = $.parseJSON(model.get('feature_flags'));

  if(_.has(feature_flags, feature) && feature_flags[feature] == true){
    return true;
  }
  return false;
};